// CRITICAL: Use window.ReactOnRails instead of import to avoid splitChunks
// creating separate module instances with separate component stores.
// See: https://github.com/shakacode/react_on_rails/issues/991
const reactOnRailsModule = require('react-on-rails');
window.ReactOnRails = window.ReactOnRails || reactOnRailsModule.default;
const ReactOnRails = window.ReactOnRails;

import AddConfirmToCalendar from '../bundles/AddConfirmToCalendar/components/AddConfirmToCalendar';
import CheckoutAccordionApp from '../bundles/CheckoutAccordion/startup/CheckoutAccordionApp';
import MapWithMarker from '../bundles/MapWithMarker/components/MapWithMarker';
import AddToAppleWalletContainer from '../bundles/AddToWallet/AddToAppleWalletContainer';
import AddToGoogleWalletContainer from '../bundles/AddToWallet/AddToGoogleWalletContainer';
import MembershipCheckoutWidgetApp from '../bundles/MembershipCheckoutWidget/startup/MembershipCheckoutWidgetApp';
import MembershipSuccessApp from '../bundles/MembershipSuccess/startup/MembershipSuccessApp';
import RotatingBarcodeContainer from '../bundles/RotatingBarcode/RotatingBarcodeContainer';
import PublicFolderViewer from '../bundles/PublicFolderViewer/components/PublicFolderViewer';
import PublicGivingCampaignApp from '../bundles/PublicGivingCampaign/startup/PublicGivingCampaignApp';
import SeriesPassCheckout from '../bundles/SeriesPassCheckout/components/SeriesPassCheckout';
import ClassRegistrationCheckout from '../bundles/ClassRegistrationCheckout/components/ClassRegistrationCheckout';
import ClassWaitlistJoin from '../bundles/ClassWaitlistJoin/components/ClassWaitlistJoin';
import ClassCheckoutNote from '../bundles/ClassCheckoutNote/components/ClassCheckoutNote';
import ClassNextSessionSignup from '../bundles/ClassNextSessionSignup/components/ClassNextSessionSignup';
import SeriesEntryPicker from '../bundles/SeriesEntryPicker/components/SeriesEntryPicker';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  SeriesPassCheckout,
  ClassRegistrationCheckout,
  ClassWaitlistJoin,
  ClassCheckoutNote,
  ClassNextSessionSignup,
  SeriesEntryPicker,
  AddConfirmToCalendar,
  CheckoutAccordionApp,
  MapWithMarker,
  AddToAppleWalletContainer,
  AddToGoogleWalletContainer,
  MembershipCheckoutWidgetApp,
  MembershipSuccessApp,
  RotatingBarcodeContainer,
  PublicFolderViewer,
  PublicGivingCampaignApp
});
